import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./BenefisCategoryUIHelpers";

const BenefisCategoryUIContext = createContext();

export function useBenefisCategoryUIContext() {
  return useContext(BenefisCategoryUIContext);
}

export const BenefisCategoryUIConsumer = BenefisCategoryUIContext.Consumer;

export function BenefisCategoryUIProvider({
  benefisCategoryUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initBenefisCategory = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initBenefisCategory,
    newBenefisCategoryButtonClick:
      benefisCategoryUIEvents.newBenefisCategoryButtonClick,
    openEditBenefisCategoryPage:
      benefisCategoryUIEvents.openEditBenefisCategoryPage,
    openDeleteBenefisCategoryPage:
      benefisCategoryUIEvents.openDeleteBenefisCategoryPage,
  };

  return (
    <BenefisCategoryUIContext.Provider value={value}>
      {children}
    </BenefisCategoryUIContext.Provider>
  );
}
